module.exports = __webpack_public_path__ + "img/topicSustainability.44712033.webp";